import { EVENT_STATUSES } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import EventStatusePage from "./container/EventStatusePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: EVENT_STATUSES,
    withSidebar: true,
    withAppBar: true,
    component: EventStatusePage,
  };
}
